<script>
import SplitText from '../../utilities/SplitText';
import LiquidDisplacement from '../components/liquid-displacement';
import magnetic from '../components/Magnetic.vue';
import parallaxBg from '../components/ParallaxBg.vue';

export default {
    components: {
        magnetic,
        parallaxBg,
    },

    data() {
        return {
            params: {
                webGLCanvasID: 'liquid-canvas',
                planeElementID: 'liquid-asset',

                // TWEAK THOSE VALUES TO CHANGE OVERALL EFFECT

                // size of the effect (0: no effect, 1: full window)
                pointerSize: 0.24,
                // how much to increase/decrease opacity on each frame
                opacitySpeed: 0.0145,
                // strength of the velocity of the mouse effect
                velocityStrength: 0.35,
                // the bigger the more displacement
                displacementStrength: 0.56,
                // does not change anything visually, but the smaller the scale the better the performance
                canvasScale: 0.25
            }
        };
    },

    mounted() {
        // const liquidHero = new LiquidDisplacement(this.params);
        // liquidHero.addPlane();ß

        this.$root.$on('ready', this.animateIn);
    },

    methods: {
        animateIn() {
            const tl = greensock.timeline();

            const title = this.$refs.heroTitle;
            const split = new SplitText(title, {
                type: 'words, chars'
            });

            greensock.set(title, { perspective: 400, opacity: 1 });

            tl.from(split.chars, {
                opacity: 0,
                scale: 0,
                y: 80,
                rotationX: 150,
                duration: 1,
                stagger: 0.05,
                delay: 0.32,
                transformOrigin: '0% 50% -50',
                ease: 'back.inOut'
            })
                .fromTo(
                    this.$refs.divider,
                    {
                        opacity: 1,
                        scale: 0
                    },
                    {
                        opacity: 1,
                        scale: 1,
                        duration: 0.8,
                        transformOrigin: 'left',
                        ease: 'circ.inOut'
                    },
                    '<0.64'
                )
                .to(
                    this.$refs.date,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '>-0.2'
                )
                .to(
                    this.$refs.category,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0.2'
                )
                .to(
                    this.$refs.button,
                    {
                        opacity: 1,
                        duration: 0.4
                    },
                    '<0.2'
                );
        }
    }
};
</script>
